import 'leaflet';
import 'leaflet/dist/leaflet.css';
import '../css/App.css';

$(document).ready(function() {

    var map = new L.Map("map", {
        center: new L.LatLng(47.0349968, 4.9241846),
        zoom: 6,
        zoomControl: false
        });

    L.control.zoom({
        position: 'topright'
    }).addTo(map);


//Definition des différents layers
const overlays = new L.FeatureGroup();

const osm = L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
    maxZoom: 22,
    maxNativeZoom: 19,
    continuousWorld: true,
    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>',
    id: 'osm'
}).addTo(map);
//Definition de la carte

map.createPane("pane250").style.zIndex = 250; // between tiles and overlays
map.createPane("pane260").style.zIndex = 260; // between tiles and overlays
map.createPane("pane450").style.zIndex = 450; // between overlays and shadows
map.createPane("pane620").style.zIndex = 620; // between markers and tooltips
map.createPane("pane800").style.zIndex = 800; // above popups

function infoAA (feature, layer) {
    const properties = feature.properties;
    const popup = L.popup({
        closeButton: true
    }).setContent("<table class='table table-striped table-bordered table-condensed'>" +
        "<h5> Informations de la couche " +layer.options.name+ ": </h5> " +
        "<tr><th>Nom de l'aire urbaine &nbsp;</th><td>" + properties.Data_standardise_AIRES_ATTRACTION_VILLES + "</td></tr>" +
        "<table>");
    layer.bindPopup(popup);
    layer.openPopup();
}

function infoCommunes (feature, layer) {
    const properties = feature.properties;
    const popup = L.popup({
        closeButton: true
    }).setContent("<table class='table table-striped table-bordered table-condensed'>" +
        "<h5> Informations de la couche " +layer.options.name+ ": </h5> " +
        "<tr><th>Nom de la commune &nbsp;</th><td>" + properties.NOM_COM + "</td></tr>" +
        "<tr><th>Code INSEE &nbsp;</th><td>" + properties.INSEE_COM + "</td></tr>" +
        "<tr><th>Population &nbsp;</th><td>" + properties.POPULATION + "</td></tr>" +
        "<table>");
    layer.bindPopup(popup);
    layer.openPopup();
}

//Zones de CV

    var AiresUrbaines = L.geoJson(AiresUrb,{
        color: "red",
        fillColor: "red",
        fillOpacity: 0.3,
        weight: 2,
        zIndex: 0,
        pane: "pane250",
        name: 'Aires urbaines',
        onEachFeature: infoAA
    });
    AiresUrbaines.name = 'AiresUrbaines';
    overlays.addLayer(AiresUrbaines);
    //AiresUrbaines.bringToBack();

//Zones de RP
	
    var communes = L.geoJson(communesHabs,{
        color: "black",
        fillColor: "blue",
        fillOpacity: 0.4,
        weight: 0.4,
        zIndex: 10,
        pane: "pane260",
        name: 'Communes + de 10 000 habs',
        onEachFeature: infoCommunes
    }); 
    communes.name = 'communes';
    overlays.addLayer(communes);
    //communes.bringToFront();

    $("input[name='overlays']").on('click', function(e) {
        e.stopPropagation();
        const idCheckbox=$(this).attr('id');
        //On boucle dans les overlays pour sélectionner la couche à afficher en fonction de la checkbox cliquée
        overlays.eachLayer(layer => {
            if(layer.name==idCheckbox){
                if (map.hasLayer(layer)) {
                    map.removeLayer(layer);
                } else {
                    map.addLayer(layer);
                }
            }  
        });
    });


});